import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding: 24px 20px 32px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  width: 100%;
  height: 100%;

  .ant-form-item {
    width: 100%;
    margin-bottom: 0 !important;
  }

  .ant-form-item-required {
    &::before {
      display: none !important;
    }
  }
`;
